// @flow

import Resource from 'speed-js-core/src/api/Resource';

export default class CaseCloseResource extends Resource {
    basePath: string = 'cases/close/';

    objectPath: string = 'cases/close/{ident}/';
}
